import { createModalSelectors } from '@core/modal/model/selectors'
import { createModalSlice } from '@core/modal/model/slice'

/**
 *
 */
export function registerModals<Configs>(modals: {
  [T in keyof Configs]: React.FC<Configs[T]>
}) {
  const getModalComponent = <T extends keyof Configs>(
    type: T,
  ): React.FC<Configs[T]> | undefined => {
    return modals[type]
  }

  const createSlice = () => createModalSlice<Configs>()
  const selectors = createModalSelectors<Configs>()
  return { getModalComponent, selectors, createSlice }
}
